export default __webpack_public_path__ + "static/media/_table-sort-descend-active-icon.5798c26d.svg";